import { useStoreSystem } from "../store";
import shallow from "zustand/shallow";


export const useLoading = () => {
    const { isLoading, setIsLoading, isPdfPreparation, setIsPdfPreparation } = useStoreSystem((state) => ({
        isLoading: state.isLoading,
        setIsLoading: state.setIsLoading,
        isPdfPreparation: state.isPdfPreparation,
        setIsPdfPreparation: state.setIsPdfPreparation,
    }), shallow);

    return {
        isLoading,
        setIsLoading,
        isPdfPreparation,
        setIsPdfPreparation
    };
};
